<template>
  <div>
    <div class="poster" ref="poster">
      <template v-if="!src">
        <ui-image :src="cover" v-if="cover">
        </ui-image>
        <img :src="logo" alt="" class="poster-logo">
        <h3 class="title">{{book.title}}</h3>
        <div class="qrcode" v-if="qrcode"> <img width="120" height="120" :src="qrcode">
          <ui-avatar v-if="book.userInfo" :url="avatar" size="sm"> </ui-avatar>
        </div>
        <p class="date"> <span v-if="book.userInfo">{{book.userInfo.username}} - </span> {{ i18n.d(new Date(book.created), "long") }}</p>
      </template>
      <template v-else>
        <img :src="src" alt="" class="poster-image">
      </template>
    </div>
    <ui-button full @click.native="render">{{i18n.t('downloadQrcode')}}</ui-button>
  </div>
</template>
<script>
import api from '../api/index.js'
import i18n from '../locale/i18n.js'
import logo from '../assets/logo.png'
export default {

  name: 'poster',

  data() {
    return {
      canvas: '',
      qrcode: '',
      cover: '',
      avatar: '',
      src: '',
      i18n: i18n,
      logo: logo
    }
  },
  props: {
    book: {
      type: Object,
      reuqired: true
    },
    link: {
      type: String,
      reuqired: true
    }
  },
  mounted() {
    import('qrcode').then(m => {
      return m.default.toDataURL(this.link, {
        width: 140,
      })
    }).then(qrcode => {
      this.qrcode = qrcode
    })
    this.getFile()
  },
  methods: {
    getFile() {
      if (this.book.fileList[0]) {
        api.proxyImage({
          id: this.book.fileList[0],
          size: 'sm'
        }).then(res => {
          this.cover = res.data.file
        })
      }
      if (this.book.userInfo && this.book.userInfo.avatar) {
        api.proxyImage({
          id: this.book.userInfo.avatar,
          size: 'sm'
        }).then(res => {
          this.avatar = res.data.file
        })
      }

    },
    render() {
      import('html2canvas').then(m => {
        const html2canvas = m.default
        return html2canvas(this.$refs['poster'], { logging: false })
      }).then(canvas => {
        this.src = canvas.toDataURL('image/png')
        let link = document.createElement('a')
        link.setAttribute('href', this.src)
        link.setAttribute('download', `${this.book.title}.png`)
        link.click()

      })

    }
  }
}

</script>
